<template>
    <div>
        <h1 class="title is-1">{{ $t('menu.contact') }}</h1>
        <div>
            <p class="is-size-5">
                {{ $t('title') }}
            </p>
            <p>
                {{ $t('contact.address') }}<br>
                {{ $t('contact.telString') }} {{ telNumber }}<br>
                {{ $t('contact.emailString') }} {{ emailAddress }}
            </p>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                telNumber: '+36 (68) 456-006',
                emailAddress: 'szerb.iskola@gmail.com'
            }
        }
    }
</script>